<template>
    <div class="bidder-child-page">
        <div class="page-header">
            <div class="page-header-content">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title">答疑澄清</h2>
            </div>
            <div class="header-action">
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
            </div>
        </div>

        <div class="content-container">
            <el-table :data="tableData" stripe border style="width: 100%" class="clarification-table">
                <el-table-column prop="no" label="NO." width="80" align="center">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="bidInvitationDocumentsName" label="文件名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="bidInvitationDocumentsCode" label="文件编码" show-overflow-tooltip></el-table-column>
                <el-table-column prop="bidValidity" label="投标有效期(天)" align="center"></el-table-column>
                <el-table-column prop="bidOpeningTime" label="投标文件递交截止时间(开标时间)" align="center"></el-table-column>
                <el-table-column prop="decryptionDeadline" label="投标文件解密截止时间" align="center"></el-table-column>
                <el-table-column prop="documentType" label="文件类型" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.documentType === 1">文件</span>
                        <span v-if="scope.row.documentType === 2">补遗书</span>
                        <span v-if="scope.row.documentType === 3">澄清文件</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="审核状态" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status === 0">暂存</span>
                        <span v-if="scope.row.status === 1">提交</span>
                    </template>
                </el-table-column>

                <el-table-column label="详细信息" align="center">
                    <template slot-scope="scope">
                        <div class="action-buttons">
                            <el-button type="text" size="small" @click="handleViewDetails(scope.row)">详情</el-button>
                            <el-button v-if="scope.row.status === 0" type="text" size="small"
                                @click="handleViewDel(scope.row)">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 补遗书弹窗（只读模式） -->
        <el-dialog title="补遗书详情" :visible.sync="addendumDialogVisible" width="50%"
            :close-on-click-modal="false" :close-on-press-escape="false" :append-to-body="true" class="addendum-dialog">

            <el-form :model="addendumForm" label-width="200px" class="dialog-content">
                <!-- 招标项目名称 -->
                <el-form-item label="招标项目名称:">
                    <el-input v-model="addendumForm.projectName" class="form-input" disabled>
                    </el-input>
                </el-form-item>
                <!-- 适用标段 -->
                <el-form-item label="适用标段:">
                    <el-select v-model="addendumForm.bidSectionCodes" class="form-input" multiple
                        collapse-tags disabled>
                        <el-option v-for="item in (addendumForm.bidSectionList || [])"
                            :key="item.bidSectionCode"
                            :label="item.bidSectionName"
                            :value="item.bidSectionCode" />
                    </el-select>
                </el-form-item>
                <!-- 适用文件 -->
                <el-form-item label="适用文件:">
                    <el-input v-model="addendumForm.bidInvitationDocumentsName" class="form-input" disabled>
                    </el-input>
                </el-form-item>
                <!-- 补遗书名称 -->
                <el-form-item label="补遗书名称:">
                    <el-input v-model="addendumForm.bidInvitationDocumentsName" class="form-input" disabled>
                    </el-input>
                </el-form-item>
                <!-- 投标文件递交截止时间(开标时间) -->
                <el-form-item label="投标文件递交截止时间:">
                    <el-input v-model="addendumForm.bidOpeningTime" class="form-input" disabled>
                    </el-input>
                </el-form-item>
                <!-- 投标文件解密截止时间 -->
                <el-form-item label="投标文件解密截止时间:">
                    <el-input v-model="addendumForm.decryptionDeadline" class="form-input" disabled>
                    </el-input>
                </el-form-item>
                <!-- 补遗内容 -->
                <el-form-item label="补遗内容:">
                    <el-input v-model="addendumForm.content" type="textarea" :rows="4" class="form-textarea" disabled>
                    </el-input>
                </el-form-item>
                <!-- 已上传的附件 -->
                <el-form-item label="已上传的附件:" v-if="addendumForm.attachments && addendumForm.attachments.length > 0">
                    <el-table :data="addendumForm.attachments" style="width: 100%" border>
                        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                        <el-table-column prop="fileName" label="文件名" show-overflow-tooltip></el-table-column>
                        <el-table-column label="操作" width="150" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="handleDownloadAttachment(scope.row)">
                                    <i class="el-icon-download"></i> 下载
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addendumDialogVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getBidderFlowTitle } from '@/utils/projectInfo.js'
import { getClarificationListForCq, getClarificationDetail } from '@/api/agent/api'
import { getFileList } from '@/api/base/api'
export default {
    name: 'BidClarification',
    data() {
        return {
            
            projectTitle: '',
            projectCode: this.$route.query.projectCode,
            sectionCode: this.$route.query.sectionCode || '',
            tableData: [],
            pagination: {
                currentPage: 1,
                total: 0
            },
            pageSize: 10,
            // 补遗书弹窗
            addendumDialogVisible: false,
            // 补遗书表单数据
            addendumForm: {
                projectName: '',
                bidSectionCodes: [],
                bidSectionList: [],
                bidInvitationDocumentsCode: '',
                bidInvitationDocumentsName: '',
                bidOpeningTime: '',
                decryptionDeadline: '',
                content: '',
                attachments: []
            },

        }
    },
    mounted() {
        this.getProjectInfo()
        this.loadData()
        this.getClarificationListForCq()
    },
    methods: {
           // 查看详情
        handleViewDetails(row) {
            this.getClarificationDetail(row)
        },
        // 获取澄清-补遗 文件详情
        async getClarificationDetail(row) {
            try {
                const res = await getClarificationDetail(row.bidInvitationDocumentsCode)
                if (res.code === 200 && res.data) {
                    const data = res.data
                    const bidSectionConfig = data.bidSectionConfig || {}
                    
                    // 如果 documentType 为 2，打开补遗书弹窗
                    if (data.documentType === 2) {
                        // 赋值补遗书表单数据
                        this.addendumForm = {
                            projectName: data.projectName || '',
                            bidSectionCodes: (data.bidSectionList || []).filter(item => item.isSelected === 1).map(item => item.bidSectionCode),
                            bidSectionList: data.bidSectionList || [],
                            bidInvitationDocumentsCode: data.bidInvitationDocumentsCode || '',
                            bidInvitationDocumentsName: data.bidInvitationDocumentsName || '',
                            bidOpeningTime: bidSectionConfig.bidOpeningTime || data.bidOpeningTime || '',
                            decryptionDeadline: bidSectionConfig.decryptionDeadline || data.decryptionDeadline || '',
                            content: data.content || '',
                            attachments: []
                        }
                        // 如果有 fileGuid，获取附件列表
                        if (data.fileGuid) {
                            await this.getAttachmentList(data.fileGuid)
                        }
                        // 打开补遗书弹窗
                        this.addendumDialogVisible = true
                    } else if (data.documentType === 3) {
                        // 澄清文件，跳转到澄清文件页面
                       this.$router.push({
                            path: '/agentHome/clarification',
                            query: {
                                projectCode: this.projectCode,
                                isViewMode: true,
                                bidInvitationDocumentsCode: row.bidInvitationDocumentsCode
                            }
                        })
                    }
                } else {
                    this.$message.error(res.msg || '获取详情失败')
                }
            } catch (error) {
                console.error('获取澄清-补遗 文件详情失败:', error)
                this.$message.error('获取详情失败')
            }
        },

        // 获取附件列表
        async getAttachmentList(fileGuid) {
            try {
                const res = await getFileList({ fileGuid })
                if (res.code === 200 && res.data) {
                    this.addendumForm.attachments = (res.data || []).map(file => ({
                        fileId: file.fileId,
                        fileName: file.fileName,
                        fileSize: file.fileSize,
                        filePath: file.filePath
                    }))
                }
            } catch (error) {
                console.error('获取附件列表失败:', error)
            }
        },

        // 下载附件
        handleDownloadAttachment(file) {
            if (!file.fileUrl) {
                this.$message.error('文件下载地址不存在')
                return
            }
            try {
                const link = document.createElement('a')
                link.href = file.fileUrl
                link.download = file.fileName || '下载文件'
                link.style.display = 'none'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                this.$message.success(`开始下载文件：${file.fileName}`)
            } catch (error) {
                console.error('下载文件失败:', error)
                this.$message.error('下载文件失败，请重试')
            }
        },

        getClarificationListForCq() {
            getClarificationListForCq(this.projectCode).then(res => {
                if (res.code === 200) {
                    this.tableData = res.data.records || []
                    this.pagination.total = res.data.total || 0
                    this.pagination.currentPage = res.data.current || 1
                }
            })
        },
        // 获取项目信息
        async getProjectInfo() {
            this.projectTitle = await getBidderFlowTitle(this.sectionCode);
        },
        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },
        // 查看详情
        handleView(row) {
            this.$message.info(`查看答疑澄清内容：${row.documentName}`)
            // 这里实现具体的查看逻辑
        },
        // 分页大小改变
        handleSizeChange(val) {
            this.pageSize = val
            this.currentPage = 1
            this.loadData()
        },
        // 当前页改变
        handleCurrentChange(val) {
            this.currentPage = val
            this.loadData()
        },
        // 加载数据
        loadData() {
            // 这里实现数据加载逻辑
            console.log(`加载第${this.currentPage}页，每页${this.pageSize}条`)
        },
        // 获取答疑澄清数据
        fetchClarificationData() {
        }
    },

}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.bidder-child-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;
}

.page-header-content {
    display: flex;
    flex-direction: column;
    text-align: start;
}

.header-action {
    text-align: end;
    flex-shrink: 0;
}

.page-title {
    color: @gray-700;
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.4;
}

.content-container {
    padding: 20px;
    border-radius: 8px;
    box-shadow: @shadow-sm;
    background: #fff;
    text-align: start;
}

.clarification-table {
    border-radius: 4px;
    overflow: hidden;

    /deep/ th {
        background: @gray-50 !important;
        color: @gray-700 !important;
        font-weight: 600;
        border-color: @gray-200 !important;
    }

    /deep/ td {
        color: @gray-600;
        border-color: @gray-200 !important;
    }
}

.action-buttons {
    display: flex;
    gap: 8px;
    justify-content: center;

    .el-button {
        color: @gray-600;

        &:hover {
            color: @primary-color;
        }
    }
}

/deep/ .el-dialog {
    border-radius: 8px;
}

/deep/ .el-dialog__header {
    background: @gray-50;
    border-bottom: 1px solid @gray-200;
}

/deep/ .el-dialog__title {
    color: @gray-700;
    font-weight: 600;
}

@media (max-width: 768px) {
    .bidder-child-page {
        padding: 16px;
    }

    .page-header {
        flex-direction: column;
        align-items: stretch;
    }

    .header-action {
        text-align: left;
    }

    .page-title {
        font-size: 20px;
    }

    .content-container {
        padding: 16px;
    }
}

.page-title {
    color: #333;
    margin: 0;
    font-weight: bold;
}

.content-wrap {
    padding: 20px;
    border-radius: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-top: 20px;
    background: white;
}

.clarification-table {
    .el-table__header {
        background-color: #f5f7fa;
    }

    .el-table__header th {
        background-color: #f5f7fa;
        color: #333;
        font-weight: 600;
    }

    .view-btn {
        color: #409EFF;
        font-weight: 500;

        &:hover {
            color: #66b1ff;
        }
    }
}


.pagination-container {
    margin-top: 20px;
    text-align: right;
}
</style>